const locales = {
	EN: "en",
	RU: "ru",
};

export default locales;
